import { createSelector } from 'reselect'
import isSelf from 'components/people/person/utils/isSelf'
import memberOwner from 'components/people/person/memberOwner'

export default createSelector(
  ({ auth }, personId) => isSelf(auth.id, personId),
  (state, personId) => memberOwner(state, personId),
  (self, owner) => self || owner
)
